import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputModule } from '@nibtravel/shared/ui/forms/input';
import {
  MbscRangeModule,
  MbscCalendarModule,
  mobiscroll,
} from '@mobiscroll/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ModelsModule } from '@nibtravel/shared/util/models';

import { DatePickerComponent } from './date-picker.component';

mobiscroll.customTheme('whiteLabel', 'material');

@NgModule({
  imports: [
    CommonModule,
    InputModule,
    ReactiveFormsModule,
    MbscRangeModule,
    MbscCalendarModule,
    ModelsModule,
  ],
  declarations: [DatePickerComponent],
  exports: [DatePickerComponent],
})
export class DatePickerModule {}
